import { logger } from '@shared/utils/logger';
import type { ReactNode } from 'react';
import { Component } from 'react';

import ErrorPage from './error-page';
import { captureRuntimeErrorInPostHog } from '@core/api/capture-runtime-error-in-posthog';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    logger.error(error?.message, error);
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    captureRuntimeErrorInPostHog(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage error={this.state.error} />;
    }

    return this.props.children;
  }
}
